import React, { useEffect, useState } from 'react'
import {
    GoogleMap, MarkerF, Circle, Marker, InfoWindow,
    CircleF
} from "@react-google-maps/api";
import "./TutorMaps.scss";
import { MapProps } from '../../Models/TutorModel';
import TutorImg from "../../Assets/Tutor/mapTutorIcon.svg";
import tutor_img from "../../Assets/Tutor/tutor_image.png";
import shareIcon from "../../Assets/Tutor/share.svg";
import LikeIcon from "../../Assets/Tutor/LikeIcon.svg";
import locationIcon from "../../Assets/Tutor/location.svg";
import experienceIcon from "../../Assets/Tutor/experience.svg";
import StarIcon from '@mui/icons-material/Star';
import teaching_mode from "../../Assets/Tutor/teaching_mode.svg";
import grades from "../../Assets/Tutor/grades.svg";
import curriculum from "../../Assets/Tutor/curriculum.svg";
import { GetSessionStorageData, SetSessionStorageData, encryptPassData, nullUndefinedEmptyCheck } from '../../Utilities/Helpers/Helper';
import { API_END_POINTS, AUTHENTICATION, GLOBAL_CONSTANTS, ROUTES, TUTORMAPCONSTANT } from '../../Constants/Constants';
import { setLocation, setLocationName, setLoginSignUpOpen } from '../../Redux/Reducer/Reducer';
import { useDispatch, useSelector } from 'react-redux';
import { axiosInstance } from '../../Utilities/Interceptor/Interceptor';
import toast from 'react-hot-toast';
import Tutorfavourites from "../../Assets/HeartFill/TutorFill.svg";
import { useNavigate } from 'react-router-dom';
import WebShareComponent from '../WebShare/WebShare';

const TutorMaps = ({ zoom, radius, containerStyle, disable, zoomControl, draggable, clickableIcons, tutorList, getOneTutor, lat, lang, filter, searchValue, initFilter, initSort }: MapProps) => {
    const [currentLocation, setCurrentLocation] = useState<any>(null);
    const [selectedLocation, setSelectedLocation] = useState<any>(null);
    const [TutorList, setTutorList] = useState<any>([]);
    const [userProfileImg, setUserProfileImg] = useState<any>();
    const [referredOrigin, setReferredOrigin] = useState<any>(null);
    const [preferredMarker, setPreferredMarker] = useState<{ lat: number; lng: number } | null>(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isMobileView, setIsMobileView] = useState<boolean>(false);
    const [showMapTooltip, setShowMapTooltip] = useState<boolean>(false);
    const [tooltipPos, setTooltipPos] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
    const [showMapTooltipMobile, setShowMapTooltipMobile] = useState<boolean>(false);

    const HeaderLoction: any = useSelector((state: any) => state.locationReducer.location);
    const language: any = useSelector((state: any) => state.languageReducer.language);
    const isLoaded = useSelector((state: any) => {
        return state.googleMapLoadedReducer.isGoogleMapLoaded;
    });

    useEffect(() => {
        if (window.innerWidth <= 636) {
            setIsMobileView(true);
        }
    }, []);

    useEffect(() => {
        setShowMapTooltipMobile(isMobileView);
    }, [isMobileView]);

    useEffect(() => {
        const storedLocation = GetSessionStorageData(AUTHENTICATION.SHARED.TUTOR_LOCATION);
        let locationToUse;

        if (HeaderLoction?.lat && HeaderLoction?.lng) {
            locationToUse = {
                lat: parseFloat(HeaderLoction.lat),
                lng: parseFloat(HeaderLoction.lng)
            };
        } else if (storedLocation) {
            try {
                const parsedLocation = JSON.parse(storedLocation);
                locationToUse = {
                    lat: parseFloat(parsedLocation.lat),
                    lng: parseFloat(parsedLocation.lng)
                };
            } catch (e) {
                console.error('Error parsing stored location:', e);
            }
        } else if (lat && lang) {
            locationToUse = {
                lat: parseFloat(lat),
                lng: parseFloat(lang)
            };
        }

        if (locationToUse) {
            setCurrentLocation(locationToUse);
            if (!HeaderLoction || 
                HeaderLoction.lat !== locationToUse.lat || 
                HeaderLoction.lng !== locationToUse.lng) {
                dispatch(setLocation(locationToUse));
                SetSessionStorageData(AUTHENTICATION.SHARED.TUTOR_LOCATION, JSON.stringify(locationToUse));
            }
            
            if (isLoaded && locationToUse.lat && locationToUse.lng) {
                TutorListApi();
            }
        }
        
        setUserProfileImg(GetSessionStorageData(AUTHENTICATION.SHARED.PROFILE_PICTURE));
    }, [lat, lang, HeaderLoction, isLoaded]); 

    const payload = () => {
        var priceValue: any = [];
        var experienceValue: any = [];
        var gradeValue: any = [];

        if (initFilter.price[0] === filter.price[0] && initFilter.price[1] === filter.price[1]) {
            priceValue = []
        } else {
            priceValue = {
                min: filter.price[0],
                max: filter.price[1],
            }
        }
        if (initFilter.experience[0] === filter.experience[0] && initFilter.experience[1] === filter.experience[1]) {
            experienceValue = []
        } else {
            experienceValue = {
                min: filter.experience[0],
                max: filter.experience[1],
            }
        }
        if (initFilter.grade[0] === filter.grade[0] && initFilter.grade[1] === filter.grade[1]) {
            gradeValue = []
        } else {
            gradeValue = {
                min: filter.grade[0],
                max: filter.grade[1],
            }
        }

        const locationData = HeaderLoction || currentLocation || { lat: parseFloat(lat), lng: parseFloat(lang) };
        
        return {
            latitude: locationData.lat?.toString(),
            longitude: locationData.lng?.toString(),
            radius: radius / 1000,
            search: searchValue ? searchValue : "",
            price: priceValue,
            experience: experienceValue,
            grade: gradeValue,
            courses: filter.courses,
            mode_of_teaching: filter.mode_of_teaching,
            gender: filter.gender,
            curriculum: filter.curriculum,
            rating: filter.rating,
        }
    }

    const TutorListApi = () => {
        const pay = payload();
        if (!pay.latitude || !pay.longitude) {
            console.warn('TutorListApi: Missing coordinates, skipping API call');
            return;
        }

        axiosInstance
            .post(`${API_END_POINTS.OPTIMIZED_TUTOR_LIST}`, pay)
            .then((response: any) => {
                const rawTutors: any[] = response?.data?.result?.data || [];
                const filteredTutors = rawTutors.filter(
                    (tutor) => tutor.is_slots_available === true
                );

                setTutorList((prev: any[]) => {
                    if (JSON.stringify(prev) !== JSON.stringify(filteredTutors)) {
                        if (typeof tutorList === 'function') {
                            tutorList(filteredTutors);
                        }
                        return filteredTutors;
                    }
                    return prev;
                });
            })
            .catch((err) => {
                console.error('TutorListApi error:', err);
                setTutorList([]);
            });
    };

    const mapOptions = {
        disableDefaultUI: disable,
        zoomControl: zoomControl,
        draggable: draggable,
        clickableIcons: clickableIcons,
        disableDoubleClickZoom: disable,
        gestureHandling: "greedy",
        styles: [
            {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' },
                ],
            },
        ],
    };

    useEffect(() => {
        if (initSort?.price || initSort?.rating) {
            handleProceedSort(initSort?.price, initSort?.rating)
        }
    }, [initSort])

    const handleProceedSort = (checkedPrice: any, checkedRating: any) => {
        if (checkedPrice == 'high') {
            const sortedData = [...TutorList].sort((a: any, b: any) => b?.least_price - a?.least_price);
            setTutorList(sortedData);
        } else if (checkedPrice == 'low') {
            const sortedData = [...TutorList].sort((a: any, b: any) => a?.least_price - b?.least_price);
            setTutorList(sortedData)
        } else if (checkedRating == 'high') {
            const sortedData = [...TutorList].sort((a: any, b: any) => b?.least_rating - a?.least_rating);
            setTutorList(sortedData)
        } else if (checkedRating == 'low') {
            const sortedData = [...TutorList].sort((a: any, b: any) => a?.least_rating - b?.least_rating);
            setTutorList(sortedData)
        }
    }

    const handleChangeFavourites = (val: any, id: any) => {
        const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
        if (nullUndefinedEmptyCheck(accessToken)) {
            var payload = {
                service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.ONE_INT,
                service_provider: id,
                is_favourite: !val
            }
            axiosInstance
                .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload)
                .then((Response: any) => {
                    if (Response?.data?.status) {
                        toast.success(Response?.data?.message, {
                            position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION
                        });
                        TutorListApi()
                    }
                })
                .catch((error) => {
                    console.error(" handleChangeFavourites ~ error:", error)
                });
        } else {
            dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
        }
    }

    const geocoder: any = isLoaded ? new window.google.maps.Geocoder() : '';

    const getFormattedAddress = (lat: any, lng: any) => {
        if (!geocoder) return;
        geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
            if (status) {
                var addressComponents = results[GLOBAL_CONSTANTS.INITIAL_VALUES.ZERO_INT]?.address_components;
                if (results[GLOBAL_CONSTANTS.INITIAL_VALUES.ZERO_INT]?.address_components?.length > 0) {
                    const regionComponent = addressComponents?.find((component: any) => component?.types.includes("locality"));
                    const countryComponent = addressComponents?.find((component: any) => component?.types.includes("country"));
                    const countryName = countryComponent ? countryComponent.long_name : null;
                    const regionName = regionComponent ? regionComponent.long_name : null;
                    SetSessionStorageData(AUTHENTICATION.SHARED.REGION_NAME, regionName);
                    SetSessionStorageData(AUTHENTICATION.SHARED.COUNTRY_NAME, countryName);
                    dispatch(setLocationName(countryName));
                }
            }
        });
    }

    const navigateTutorDetailedView = (Detailes: any) => {
        navigate(ROUTES.TUTORS_DETAILE_VIEW + "?id=" + encryptPassData(Detailes?.id), { state: { tutor_Detailes: Detailes } });
    }

    const handleMapClick = (event: any) => {
        let latVal: number | null = null;
        let lngVal: number | null = null;
        try {
            if (event?.latLng?.lat && event?.latLng?.lng) {
                latVal = event.latLng.lat();
                lngVal = event.latLng.lng();
            } else if (event?.lat && event?.lng) {
                latVal = event.lat;
                lngVal = event.lng;
            } else if (Array.isArray(event) && event.length >= 2) {
                latVal = event[0];
                lngVal = event[1];
            }
        } catch (err) {
            // ignore
        }
        if (latVal !== null && lngVal !== null) {
            setPreferredMarker({ lat: latVal, lng: lngVal });
            if (isMobileView) setShowMapTooltipMobile(false);
        }
    };

    const navigateTutorDetailedViewSafe = (data: any) => {
        navigateTutorDetailedView(data);
    }

    return isLoaded ? (
        <>
            <div style={{ position: "relative" }}>
                <div
                    onMouseEnter={() => !isMobileView && setShowMapTooltip(true)}
                    onMouseMove={(e: React.MouseEvent<HTMLDivElement>) => {
                        if (isMobileView) return;
                        const rect = (e.currentTarget as HTMLDivElement).getBoundingClientRect();
                        setTooltipPos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
                    }}
                    onMouseLeave={() => setShowMapTooltip(false)}
                    onTouchStart={() => setShowMapTooltipMobile(false)}
                >
                    <GoogleMap
                        id={TUTORMAPCONSTANT.MAP__ID}
                        mapContainerStyle={containerStyle}
                        zoom={zoom}
                        center={currentLocation}
                        options={mapOptions}
                        onClick={(e: any) => {
                            setSelectedLocation(null);
                            handleMapClick(e);
                            if (isMobileView) setShowMapTooltipMobile(false);
                        }}
                        onMouseOut={() => setSelectedLocation(null)}
                    >
                        <CircleF
                            center={{ lat: parseFloat(HeaderLoction?.lat), lng: parseFloat(HeaderLoction?.lng) }}
                            radius={radius}
                            options={{
                                fillColor: '#178FFF',
                                strokeColor: 'rgba(79, 139, 255, 0.60)',
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillOpacity: 0.1,
                            }}
                        />

                        {HeaderLoction && (
                            <MarkerF
                                position={HeaderLoction}
                                draggable={true}
                                zIndex={999}
                                shape={{ coords: [17, 17, 18], type: "circle" }}
                                icon={{
                                scaledSize: new window.google.maps.Size(40, 40),
                                url: userProfileImg,
                            }}
                                onDragEnd={(e: any) => {
                                    if (!e.latLng) return;
                                    
                                    const locationData = {
                                        lat: e.latLng.lat(),
                                        lng: e.latLng.lng()
                                    };
                                    
                                    SetSessionStorageData('MAP_DRAG_UPDATE', 'true');
                                    
                                    dispatch(setLocation(locationData));
                                    
                                    SetSessionStorageData(AUTHENTICATION.SHARED.TUTOR_LOCATION, JSON.stringify(locationData));
                                    SetSessionStorageData(AUTHENTICATION.SHARED.CURRENT_LOCATION, JSON.stringify(locationData));
                                    
                                    setCurrentLocation(locationData);
                                    setReferredOrigin(locationData);
                                    setPreferredMarker(locationData);
                                    
                                    if (geocoder) {
                                        geocoder.geocode({ location: locationData }, (results: any, status: any) => {
                                            if (status === 'OK' && results?.[0]) {
                                                const addressComponents = results[0].address_components;
                                                const city = addressComponents.find((component: any) => 
                                                    component.types.includes('locality') || 
                                                    component.types.includes('administrative_area_level_1')
                                                );
                                                const country = addressComponents.find((component: any) => 
                                                    component.types.includes('country')
                                                );
                                                
                                                if (city && country) {
                                                    SetSessionStorageData(AUTHENTICATION.SHARED.REGION_NAME, city.long_name);
                                                    SetSessionStorageData(AUTHENTICATION.SHARED.COUNTRY_NAME, country.long_name);
                                                    dispatch(setLocationName(`${city.long_name}, ${country.long_name}`));
                                                }
                                            }
                                        });
                                    }
                                    
                                    const mapDiv = document.getElementById(TUTORMAPCONSTANT.MAP__ID);
                                    if (mapDiv && e.domEvent) {
                                        const point = new window.google.maps.Point(
                                            e.domEvent.clientX - mapDiv.getBoundingClientRect().left,
                                            e.domEvent.clientY - mapDiv.getBoundingClientRect().top
                                        );
                                        setTooltipPos({ x: point.x + 12, y: point.y + 12 });
                                        setShowMapTooltip(true);
                                    }
                                    
                                    if (isLoaded) {
                                        TutorListApi();
                                    }
                                }}
                            />
                        )}

                        {TutorList?.map((data: any) => {
                            let object = {
                                lat: parseFloat(data.latitude),
                                lng: parseFloat(data.longitude)
                            }
                            return (
                                <Marker position={object}
                                    key={`${data.id}-tutor`}
                                    icon={{
                                        scaledSize: lat == data?.latitude && lang == data?.longitude ? new window.google.maps.Size(65, 65) : new window.google.maps.Size(40, 40),
                                        url: TutorImg,
                                }}
                                onMouseOver={() => setSelectedLocation(data)}
                                onClick={() => setSelectedLocation(data)}
                                animation={lat == data?.latitude && lang == data?.longitude ? window.google.maps.Animation.DROP : undefined}
                                >
                                    {selectedLocation === data && (
                                        <InfoWindow onCloseClick={() => setSelectedLocation(null)}
                                            options={{
                                                maxWidth: 372,
                                            }} >
                                            <div className="" onClick={() => navigateTutorDetailedViewSafe(data)} onMouseEnter={() => setSelectedLocation(data)} onMouseLeave={() => setSelectedLocation(null)}>
                                                <div className='Hover__Card' onClick={() => {
                                                    if (clickableIcons && isMobileView) {
                                                        navigateTutorDetailedViewSafe(data)
                                                    } else if (clickableIcons) {
                                                        getOneTutor(data)
                                                    }
                                                }}>
                                                    <div className='rightside_contant'>
                                                        <div className="w-100">
                                                            <div className="user__Detailes">
                                                                <div className="user__name notranslate">
                                                                    {
                                                                        language === "English"
                                                                            ? `${data.profile_details?.firstname || ""} ${data.profile_details?.lastname || ""}`.trim()
                                                                            : `${data.profile_details?.arabic_firstname || data.profile_details?.firstname} ${data.profile_details?.arabic_lastname || data.profile_details?.lastname}`.trim()
                                                                    }
                                                                </div>
                                                                <div className="user__icon__wrapper" onClick={(e) => e.stopPropagation()}>
                                                                    <WebShareComponent params={ROUTES.TUTORS_DETAILE_VIEW + "?id=" + encryptPassData(data?.id)}>
                                                                        <img src={shareIcon} alt="shareIcon" className='mb-1' />
                                                                    </WebShareComponent>
                                                                    <img src={data.is_favourite ? Tutorfavourites : LikeIcon} alt="Learn and Play"
                                                                        onClick={() => handleChangeFavourites(data.is_favourite, data?.user)} />
                                                                </div>
                                                            </div>
                                                            <div className="user__Detailes__location">
                                                                <img src={locationIcon} alt="locationIcon" className="grayIcons" />
                                                                <div className="graytext">{data.city}</div>
                                                                <img src={experienceIcon} alt="experienceIcon" className="grayIcons" />
                                                                <div className="graytext">{data?.tutor_subjects?.length > 0 ? data?.tutor_subjects[0]?.experience : ""}</div>
                                                                <img src={teaching_mode} alt="teaching_mode" className="grayIcons" />
                                                                <div className="graytext">{data?.tutor_subjects?.length > 0 ? data?.tutor_subjects[0]?.course_mode : ""}</div>
                                                            </div>

                                                            <div className="user__Detailes__Course">
                                                                <img src={grades} alt="shareIcon" />
                                                                <div className="lable" title={data?.tutor_subjects?.length > 0 ? data?.tutor_subjects[0]?.courses : ""}>{data?.tutor_subjects?.length > 0 ? data?.tutor_subjects[0]?.courses : ""}</div>
                                                                <img src={curriculum} alt="curriculum" />
                                                                <div className="lable">{data.curriculum}</div>
                                                            </div>

                                                            <div className="user__Detailes__rating">
                                                                <span className="title">{data?.tutor_subjects?.length > 0 ? "AED " + data?.tutor_subjects[0]?.final_fee : ""}</span>
                                                                <div className="d-flex gap-2 align-items-center">
                                                                    {data.rating ? (<StarIcon className="StarIcon" />) : ('')}
                                                                    <div className="card__title">{data.rating}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </InfoWindow>
                                    )}
                                </Marker>
                            )
                        })}
                    </GoogleMap>
                </div>

                {showMapTooltip && !isMobileView && (
                    <div
                        style={{
                            position: "absolute",
                            left: tooltipPos.x + 12,
                            top: tooltipPos.y + 12,
                            zIndex: 1200,
                            background: "#fff",
                            padding: "6px 10px",
                            borderRadius: 6,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            pointerEvents: "none",
                            fontSize: 13,
                            color: "#111"
                        }}
                    >
                        {language === "English"
                            ? "Drag the pin to select your preferred location"
                            : "اسحب الدبوس لتحديد موقعك المفضل "}
                    </div>
                )}

                {isMobileView && showMapTooltipMobile && (
                    <div
                        style={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            bottom: 12,
                            zIndex: 1200,
                            background: "rgba(255,255,255,0.95)",
                            padding: "8px 12px",
                            borderRadius: 8,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                            pointerEvents: "none",
                            fontSize: 13,
                            color: "#111",
                            maxWidth: "90%",
                            textAlign: "center"
                        }}
                    >
                        Tap map to select preferred region or drag the marker
                    </div>
                )}
             </div>
          </>
      ) : (<></>)
  };

export default React.memo(TutorMaps);